<div class="eas-payment">
  <p class="eas-payment__label" i18n>Amount due</p>
  <p class="eas-payment__amount">
    {{ transaction.amount | currency: transaction.currency.code }}
  </p>
</div>
<rsr-loading [loaded]="$initialized()"></rsr-loading>

<p *ngIf="canChangePaymentMethod">
  <ng-container i18n>You are paying by Credit/Debit card.</ng-container>
  <a href="" role="button" (click)="onCancel($event)" i18n>Change payment method</a>?
</p>

<ng-container *ngIf="integration.isStripe">
  <form action="/transactions/{{ transaction.id }}/capture" method="post" id="payment-form" [formGroup]="form">
    <div class="eas-stripe">
      <p ubFormLabel i18n>Card details</p>
      <div id="integrationContentElement" #integrationContentElement></div>

      @if ($initialized()) {
      <button mat-flat-button
              class="eas-payment__button"
              color="primary"
              type="button"
              (click)="onCapture()"
              [disabled]="!form.valid || isOperationInProgress" i18n>Pay now</button>
      }
    </div>
  </form>
</ng-container>

<ng-container *ngIf="integration.isMoneris">
  <div id="integrationContentElement" style="z-index: 10000;" #integrationContentElement></div>
  @if ($initialized()) {
  <button mat-flat-button
          class="eas-payment__button"
          color="primary"
          type="button"
          (click)="onCapture()"
          [disabled]="isOperationInProgress" i18n>Pay now</button>
  }
</ng-container>

<ng-container *ngIf="integration.isHeycentric">
  <div id="integrationContentElement" style="z-index: 10000;" #integrationContentElement></div>
  @if ($initialized()) {
  <button mat-flat-button
          class="eas-payment__button"
          color="primary"
          type="button"
          (click)="onCapture()"
          [disabled]="isOperationInProgress" i18n>Pay now</button>
  }
</ng-container>